import {FC} from 'react';
import {styled} from 'styled-components';

import {LoadingIndicator} from '@shared_web/components/core/loading_indicator';

import {getStateMessage} from '@website_frontend/components/header';
import {CompressedScraperItemsApi, DbDataState} from '@website_frontend/lib/db_cache';

interface LoadingStateProps {
  state: DbDataState;
  data: CompressedScraperItemsApi | undefined;
}

export const LoadingState: FC<LoadingStateProps> = ({state, data}) => {
  const message = getStateMessage(state, data);
  const isLoading = state.type !== 'success' && state.type !== 'error';

  return (
    <Container>
      <Card>
        {isLoading && (
          <LoadingIndicator
            size={48}
            thickness={4}
            opacity={0.8}
            rotation={{$rotationSpeedMs: 1200}}
            dash={{$dashSpeedMs: 1200}}
          />
        )}
        <Message>{message}</Message>
        {state.type === 'error' && (
          <ErrorDetails>Veuillez rafraîchir la page pour réessayer.</ErrorDetails>
        )}
      </Card>
    </Container>
  );
};
LoadingState.displayName = 'LoadingState';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 32px;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 48px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  min-width: 280px;
  max-width: 400px;
`;

const Message = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #666;
  line-height: 1.5;
`;

const ErrorDetails = styled.div`
  font-size: 14px;
  color: #999;
  margin-top: 8px;
`;
